module.exports = __webpack_public_path__ + "pickup-a42ae3940045aee57116fd983b9b6374.png";